<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Deferred</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Commission Deferred</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i class="fa fa-filter"></i>Filter</a>
            <div class="card-tools">
              <router-link :to="{ name: 'CommissionDeferredAdd' }" class="btn btn-success">
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <form @submit.prevent="getList()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row"></div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <button type="submit" class="btn btn-primary m-2px">
                      Search
                    </button>
                    <button type="reset" class="btn btn-warning" @click="resetFilter()">
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Client Reference-Id</th>
                    <th>Account-Id</th>
                    <th>Commission config</th>
                    <th>Amount</th>
                    <th>Commissioned amount</th>
                    <th>Can migrate</th>
                    <th>Disbursement-Id</th>
                    <th>Disbursement Reference-Id</th>
                    <th>Expected Disbursement Date</th>
                    <th>Actual Disbursement Date</th>
                    <th>Disbursed amount</th>
                    <th>Disbursement status</th>
                    <th>Disbursement message</th>
                    <th>App-Id</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="(val, index) in list.data" :key="val.id">
                    <td>{{ val.id }}</td>
                    <td>{{ val.client_ref_id }}</td>
                    <td>{{ val.account_id }}</td>
                    <td>{{ val.commission_config_id }}</td>
                    <td>{{ val.amount }}</td>
                    <td>{{ val.commission_amount }}</td>
                    <td>{{ val.can_migrate }}</td>
                    <td>{{ val.disbursement_id }}</td>
                    <td>{{ val.disbursement_ref_id }}</td>
                    <td>{{ val.expected_disbursement_date }}</td>
                    <td>{{ val.actual_disbursement_date }}</td>
                    <td>{{ val.disbursement_amount }}</td>
                    <td>{{ val.disbursement_status }}</td>
                    <td>{{ val.disbursement_message }}</td>
                    <td>{{ val.app_id }}</td>
                    <td class="text-right">
                      <router-link v-if="actionView == true" :to="{
                        name: 'CommissionDeferredShow',
                        params: { id: val.id },
                      }" class="btn btn-info btn-sm m-2px">
                        <i class="fas fa-eye"></i>
                      </router-link>
                      <router-link v-if="actionEdit == true" :to="{
                        name: 'CommissionDeferredEdit',
                        params: { id: val.id },
                      }" class="btn btn-info btn-sm m-2px">
                        <i class="fas fa-pencil-alt"></i>
                      </router-link>
                      <a v-if="actionDelete == true" class="btn btn-danger btn-sm m-2px" href="javascript:void(0)" @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getList()"></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import VuePagination from '@/components/partials/PaginationComponent';
import { CBSCommissionApi } from '@/services/api';

export default {
  name: 'CommissionDeferred',
  components: {
    VuePagination
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: true,
    actionView: false,
    actionEdit: true,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: ''
  }),
  mounted: function () {
    this.getList();
  },
  methods: {
    getList: function () {
      this.is_loading = true
      CBSCommissionApi.getDeferredCommission(this.list.current_page, this.filter, this.list.per_page)
        .then((items) => {
          this.list = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    resetFilter () {
      this.list.current_page = 1
      this.filter = {}
      this.getList()
    }
  }
}
</script>
